module.exports = __webpack_public_path__ + "img/68.b12684c8.jpg";